import request from '@/api/request'

// PC获取合同列表 pcgetcontractlist
export function getContractList(params) {
  return request({
    url: 'cases/pcgetcontractlist',
    method: 'get',
    params
  })
}

// PC获取写合同详情 pcgetxhtinfo
export function getContractDetail(params) {
  return request({
    url: 'cases/pcgetxhtinfo',
    method: 'get',
    params
  })
}

// PC律师接单写合同 pcxhtaccept
export function takeContract(params) {
  return request({
    url: 'cases/pcxhtaccept',
    method: 'post',
    data: params
  })
}

// PC提交律师写合同内容 pcxhtsubmit
export function submitContract(params) {
  return request({
    url: 'cases/pcxhtsubmit',
    method: 'post',
    data: params
  })
}

// PC获取审核合同列表 pcgetshtlist
export function getReviewList(params) {
  return request({
    url: 'cases/pcgetshtlist',
    method: 'get',
    params
  })
}

// PC获取审核合同详情 pcgetshtinfo
export function getReviewDetail(params) {
  return request({
    url: 'getcheckinfo',
    method: 'get',
    params
  })
}

// PC提交合同审核结果 pcshtsubmit
export function reviewContract(params) {
  return request({
    url: 'cases/savelawyercheckreply',
    method: 'post',
    data: params
  })
}

// PC审核合同接单律师 pcgetshtorder
export function pcgetshtorder(params) {
  return request({
    url: 'cases/laygetscorder',
    method: 'post',
    data: params
  })
}

export default {
  getContractList,
  getContractDetail,
  takeContract,
  submitContract,
  getReviewList,
  getReviewDetail,
  reviewContract,
  pcgetshtorder
} 